<template>
  <div>
    <FloatingButtonMenu
      :menu="[
        {
          icon: 'event_note',
          name: 'EVENT\nLOG',
          component: 'static',
        },
      ]"
      @select="openEventLogHandler"
    />
    <v-dialog v-model="showEventLog" persistent width="90vw">
      <Card>
        <v-toolbar
          height="50px"
          class="sub-header dialog-header elevation-0"
          color="primary"
        >
          <div class="title font-weight-bold text-xs-center">
            {{ $t("EVENT LOGS") }}
          </div>
          <v-spacer />
          <v-icon @click="showEventLog = false" large>close</v-icon>
        </v-toolbar>
        <v-divider />
        <v-layout row justify-end px-4 pt-4 pb-2>
          <v-flex xs2>
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="accent"
                v-model="date"
                :max="today"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn flat @click="dateMenu = false">Cancel</v-btn>
                <v-btn flat @click="$refs.menu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2>
            <v-menu
              ref="time_from_menu"
              v-model="timeFromMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="timeFrom"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="timeFrom"
                  label="Time From"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeFromMenu"
                v-model="timeFrom"
                :max="timeTo"
                full-width
                @click:minute="$refs.time_from_menu.save(timeFrom)"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2>
            <v-menu
              ref="time_to_menu"
              v-model="timeToMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="timeTo"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="timeTo"
                  label="Time To"
                  prepend-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="timeToMenu"
                v-model="timeTo"
                :max="maxTime"
                full-width
                @click:minute="saveTimeHandler"
              ></v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6 text-xs-right>
            <v-btn color="accent" @click="getEventLog()" dark>{{
              $t("APPLY")
            }}</v-btn>
          </v-flex>
        </v-layout>
        <Card class="px-4">
          <v-data-table
            :headers="computedHeader"
            :items="eventLogData"
            class="elevation-1 custom-data-table"
            :pagination.sync="pagination"
            hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  @click="changeSort(header.value)"
                  :class="[
                    'column sortable text-xs-left',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                >
                  {{ header.text }}
                  <v-icon small v-show="header.text != ''">arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <td class="text-xs-left pl-3">{{ props.item.timestamp }}</td>
              <td class="text-xs-left pl-3">{{ props.item.device_name }}</td>
              <td class="text-xs-left pl-3">
                {{ props.item.category.toUpperCase() }}
              </td>
              <td
                class="text-xs-left pl-3"
              >
                {{ props.item.prev_value }}
              </td>
              <td
                class="text-xs-left pl-3"
              >
                {{ props.item.current_value }}
              </td>
              <td class="text-xs-left pl-3">{{ props.item.request_status }}</td>
              <td class="text-xs-left pl-3">{{ props.item.updated_by }}</td>
            </template>
          </v-data-table>
        </Card>
      </Card>
    </v-dialog>
    <v-dialog v-model="dialogPassword" persistent max-width="30%">
      <Card class="pa-3">
        <v-card-title class="title pa-2 justify-center"
          >{{ $t("Enter the Password") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-form class="pa-2">
          {{ $t("Email") }}
          <v-text-field
            class="pa-0"
            v-model="emailId"
            autocomplete="email"
          ></v-text-field>
          {{ $t("Password") }}
          <v-text-field
            class="pa-0"
            type="password"
            v-model="password"
            autocomplete="new-password"
            required
          >
          </v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="error" @click="dialogPassword = false">{{
              $t("Cancel")
            }}</v-btn>
            <v-btn
              class="success"
              @click="
                checkPassword(emailId, password);
                dialogPassword = false;
              "
            >
              {{ $t("OK") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </Card>
    </v-dialog>
    <v-dialog v-model="allStateDialog" persistent max-width="30%">
      <Card>
        <v-toolbar height="50px" class="sub-header" color="primary">
          <v-toolbar-title class="body-2">{{
            $t("Change inverters state")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="allStateDialog = false">close</v-icon>
        </v-toolbar>
        <v-form class="pa-4">
          <v-select
            :items="invNameIdList"
            label="Selected inverters"
            :value="inverterSelectList"
            @change="onChangeHandler($event)"
            class="white--text"
            return-object
            outlined
            :item-text="(options) => options.text"
            multiple
            required
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 1" class="grey--text caption"
                >(+{{ inverterSelectList.length - 1 }} others)</span
              >
            </template>
          </v-select>

          <v-select
            class="pa-0"
            :items="[
              { text: 'ON', value: 1 },
              { text: 'OFF', value: 0 },
            ]"
            :item-text="(options) => options.text"
            return-object
            v-model="dialogInputOnOffValue"
            required
          >
          </v-select>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              class="accent"
              @click="
                allStateDialog = false;
                dialogPassword = true;
              "
            >
              {{ $t("Submit") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </Card>
    </v-dialog>
    <v-dialog
      v-model="confirmationDialog"
      persistent
      origin="center top"
      max-width="40%"
      class="dialog"
    >
      <Card class="pa-3">
        <v-card-title class="subheading"
          >{{ $t("Are you sure you want to change the state") }}?</v-card-title
        >
        <v-card-actions class="justify-end">
          <v-btn
            color="success"
            v-on:click="
              changeState();
              confirmationDialog = false;
            "
          >
            {{ $t("YES") }}</v-btn
          >
          <v-btn color="error" @click="confirmationDialog = false">{{
            $t("NO")
          }}</v-btn>
        </v-card-actions>
      </Card>
    </v-dialog>
    <v-layout row wrap px-1>
      <v-flex
        xs12
        v-for="(itemList, category) in groupedInvList"
        :key="category"
      >
        <Card class="px-2 pb-3">
          <div class="main-container" px-2>
            <div style="width: 93%">
              <div class="subheading px-2">
                {{ category.toUpperCase() }}
              </div>
            </div>
            <div style="width: 7%; textalign: right">
              <v-checkbox
                class="custom-checkbox"
                :disabled="
                  Object.keys(etilogConnected).some(
                    (etName) => etilogConnected[etName] == 0
                  )
                "
                :label="$t('Select all')"
                :value="isSelectAll"
                @change="selectAllInvHandler($event)"
              >
              </v-checkbox>
            </div>
            <div style="width: 100%">
              <v-divider class="custom-divider" />
            </div>
            <div
              style="width: 20%"
              class="text-xs-center pt-3 px-2"
              v-for="item in itemList"
              :key="item.device_id"
            >
              <Card class="pa-3" :background="'bg'">
                <v-layout row wrap justify-center align-start>
                  <v-flex xs3>
                    <img
                      class="connected_icon"
                      v-show="etilogConnected[item.etilog_id]"
                      :src="
                        isDark
                          ? require('@/assets/connection/internet_connected.svg')
                          : require('@/assets/connection/internet_connected_light.svg')
                      "
                      width="98%"
                    />
                    <img
                      v-show="!etilogConnected[item.etilog_id]"
                      :src="
                        isDark
                          ? require('@/assets/connection/no_internet.svg')
                          : require('@/assets/connection/no_internet_light.svg')
                      "
                      class="disconnected_icon"
                      width="98%"
                    />
                  </v-flex>
                  <v-flex xs8>
                    <v-layout row wrap>
                      <v-flex class="pt-3 pb-0 mb-0" xs12>
                        <span class="subheading">
                          {{ item.name }}
                        </span>
                      </v-flex>
                      <v-flex class="pt-0 pb-2 mb-0 mt-0" xs12>
                        <span class="caption">
                          {{
                            etilogConnected[item.etilog_id]
                              ? $t("Connection Established")
                              : $t("Connection Lost")
                          }}</span
                        >
                      </v-flex>
                      <v-flex>
                        <a
                          href="#"
                          :id="`${item.device_id}-${item.name}`"
                          class="toggle"
                          :class="
                            etilogConnected[item.etilog_id] && !multiple
                              ? inverterStatus[item.device_id] &&
                                inverterStatus[item.device_id] === 1
                                ? 'toggle--on'
                                : 'toggle--off'
                              : inverterStatus[item.device_id] &&
                                inverterStatus[item.device_id] === 1
                              ? 'toggle--on disabled'
                              : 'toggle--off disabled'
                          "
                          @click="(e) => toggleHandler(e, item)"
                        ></a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-checkbox
                      class="custom-checkbox"
                      :value="inverterSelectMap[item.device_id]"
                      @change="
                        soloInverterSelectHandler($event, item.device_id)
                      "
                      :disabled="!!!etilogConnected[item.etilog_id]"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 pt-3>
                    <template
                      v-for="(obj, param) in idParamMap[item.device_id]"
                    >
                      <v-text-field
                        class="parameter-text"
                        :key="`${param}-${item.device_id}`"
                        :label="obj.name"
                        type="number"
                        :value="valueMap[`${item.device_id}_${param}`]"
                        @change="
                          (e) =>
                            valueChangeHandler(
                              e,
                              obj.min,
                              obj.max,
                              item.device_id,
                              param
                            )
                        "
                        :min="obj.min"
                        :max="obj.max"
                        :hint="`Number between ${obj.min} and ${obj.max}`"
                        outline
                      ></v-text-field>
                      <!-- @input="() => validateInput(item.device_id, param, obj.min, obj.max)" -->
                      <!-- :disabled="!!!etilogConnected[item.etilog_id]" -->
                    </template>
                    <v-btn
                      color="accent"
                      dark
                      @click="clickInverter(item, 'other param')"
                      :disabled="!valueChangedForDevice[item.device_id]"
                      >{{ $t("Submit") }}</v-btn
                    >
                  </v-flex>
                </v-layout>
              </Card>
            </div>
            <div v-show="isSelectAll || multiple" style="width: 90%" />
            <div v-show="isSelectAll || multiple" style="width: 10%">
              <v-btn
                color="accent"
                dark
                @click="() => (allStateDialog = true)"
                >{{ $t("Change state") }}</v-btn
              >
            </div>
          </div>
        </Card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const moment = require("moment");
import { mapGetters, mapMutations, mapActions } from "vuex";
import { mapGettersMixin } from "@/util/mixin/index";
import Controlling from "@/services/Controlling";
const FloatingButtonMenu = () =>
  import("@/components/common/FloatingButtonMenu");

export default {
  components: {
    FloatingButtonMenu,
  },
  mixins: [mapGettersMixin],
  data() {
    return {
      dateMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: moment().subtract(15, "minutes").format("HH:mm"),
      timeTo: moment().format("HH:mm"),
      date: new Date().toISOString().substr(0, 10),
      inverterList: [],
      etilogConnected: {},
      inverterStatus: {},
      idParamMap: {},
      valueMap: {},
      prevValueMap: {},
      valueChangedForDevice: {},
      dialogPassword: false,
      confirmationDialog: false,
      allStateDialog: false,
      showEventLog: false,
      emailId: "",
      password: "",
      stateChangedForDevice: {},
      eventLogData: [],
      pagination: {
        sortBy: "Logged on",
        descending: false,
        page: 1,
        rowsPerPage: 500,
      },
      isSelectAll: false,
      inverterSelectMap: {},
      inverterSelectList: [],
      dialogInputOnOffValue: { text: "ON", value: 1 },
      multiple: false,
      snackbarList: [],
      isMultipleSnackbar: false
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", "getSelectedPlantId", "isSnackBar"]),
    today() {
      return moment().format("YYYY-MM-DD");
    },
    maxTime() {
      if (moment().isSame(this.date, "day")) {
        return moment().format("HH:mm");
      } else {
        return "23:59";
      }
    },
    computedHeader() {
      return [
        {
          text: this.$t("Logged on"),
          value: "timestamp",
          align: "left",
        },
        {
          text: this.$t("Name"),
          value: "device_name",
          align: "left",
        },
        {
          text: this.$t("Category"),
          value: "category",
          align: "left",
        },
        {
          text: this.$t("Prev parameter value"),
          value: "prev_value",
          align: "left",
        },
        {
          text: this.$t("Current parameter value"),
          value: "current_value",
          align: "left",
        },
        {
          text: this.$t("Status"),
          value: "request_status",
          align: "left",
        },
        {
          text: this.$t("User"),
          value: "updated_by",
          align: "left",
        },
      ];
    },
    groupedInvList() {
      const groupedList = _.groupBy(this.inverterList, "category");
      return groupedList;
    },
    invNameIdList() {
      return this.inverterList.map((invDetail) => {
        return { text: invDetail.name, value: invDetail.device_id };
      });
    },
    idInvDetailMap() {
      const groupedList = _.groupBy(this.inverterList, "device_id");
      return groupedList;
    },
    isMultiDialogAndSnack() {
      return `${this.isMultipleSnackbar}||${this.isSnackBar}`
    }
  },
  async mounted() {
    this.emailId = this.getUserInfo("email");
    this.listenToMqttTopics();

    const response = await Controlling.getInverterData(this.getSelectedPlantId);
    await this.getInverterList(response.data.message);
  },
  beforeDestroy() {
    this.unsubscribeToTopics();
  },
  methods: {
    ...mapActions([
      "validateUserAction"
    ]),
    ...mapMutations([
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_PROGRESS_BAR",
    ]),
    valueChangeHandler(val, min, max, id, param) {
      let data = val;
      if (this.valueMap[`${id}_${param}`] != data) {
        this.prevValueMap[`${id}_${param}`] = this.valueMap[`${id}_${param}`]
        if (data < parseFloat(min)) {
          data = parseFloat(min);
        } else if (data > parseFloat(max)) {
          data = parseFloat(max);
        }
        this.valueMap[`${id}_${param}`] = data;
        if (!this.valueChangedForDevice[id]) {
          this.valueChangedForDevice[id] = {};
        }

        this.valueChangedForDevice[id][param] = data;
      }
    },
    async openEventLogHandler() {
      this.showEventLog = true;
      await this.getEventLog();
    },
    saveTimeHandler() {
      this.$refs.time_to_menu.save(this.timeTo);
      if (
        moment(moment(`${this.date} ${this.timeTo}`)).isBefore(
          `${this.date} ${this.timeFrom}`,
          "minutes"
        )
      ) {
        this.timeFrom = this.timeTo;
      }
    },
    listenToMqttTopics() {
      this.$mqtt.subscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.$mqtt.subscribe(`epicConnection/${this.getSelectedPlantId}`);
      this.$mqtt.subscribe(`live/${this.getSelectedPlantId}/inverter`);
      this.$mqtt.subscribe(
        `control/state_change/${this.getSelectedPlantId}/inverter`
      );

      this.$mqtt.on("message", async (topic, message) => {
        const payload = JSON.parse(Buffer.from(message).toString());
        if (topic == `epicConnection/${this.getSelectedPlantId}`) {
          const { status, epicId } = payload;
          this.$set(this.etilogConnected, epicId, status);
        } else if (
          topic.startsWith(`control_feedback/${this.getSelectedPlantId}`)
        ) {
          let { device_name, device_id, device_type } = payload;

          if (device_type == "inverter") {
            console.log('control Feedback', payload)
            if (this.stateChangedForDevice.device_id != device_id) {
              return;
            }
            let param = {
              plant_id: this.getSelectedPlantId,
              device_id,
              device_type,
              category: this.stateChangedForDevice.category,
              device_name,
              updated_by: this.emailId,
              param_type: this.stateChangedForDevice.param
            };

            let snackbarContent = {
              icon: "",
              header: "",
              message: "",
            };

            if (this.stateChangedForDevice.param == 'state') {
              if (
                payload.status &&
                ((typeof payload.status == "boolean" && payload.status) ||
                  (Array.isArray(payload.status) && payload.status[0] == "true"))
              ) {
                param["prev_status"] = this.inverterStatus[device_id];
                param["current_status"] =
                  this.inverterStatus[device_id] == 1 ? 0 : 1;
                param["request_status"] = "success";
                snackbarContent.icon = "success";
                snackbarContent.message = this.$t(
                  "Successfully updated the status"
                );
              } else {
                param["prev_status"] = this.inverterStatus[device_id];
                param["current_status"] = this.inverterStatus[device_id];
                param["request_status"] = "failure";
                snackbarContent.icon = "error";
                snackbarContent.message = this.$t("Failed to update the status");
              }

              this.SET_SNACKBAR_CONTENT(snackbarContent);
              this.SET_SHOW_SNACKBAR(true);
              this.insertLog(param);
            } else if (this.stateChangedForDevice.param == 'other param') {
              const promiseList = []
              Object.keys(this.valueChangedForDevice[device_id]).forEach(
                (p) => {
                  this.isMultipleSnackbar = true;
                  let param1 = { ...param }
                  if (
                    payload[p] &&
                    ((typeof payload[p] == "boolean" && payload[p]) ||
                      (Array.isArray(payload[p]) && payload[p][0] == "true"))
                  ) {
                    param1[`prev_${p}`] = this.prevValueMap[`${device_id}_${p}`];
                    param1[`current_${p}`] = this.stateChangedForDevice[p];
                    param1["request_status"] = "success";
                    snackbarContent.icon = "success";
                    snackbarContent.message = this.$t(
                      `Successfully updated inverter ${this.stateChangedForDevice.name} - ${this.idParamMap[device_id][p].name}`
                    );
                    this.snackbarList.push(snackbarContent)
                  } else if (
                    payload[p] &&
                    ((typeof payload[p] == "boolean" && payload[p]) ||
                      (Array.isArray(payload[p]) && payload[p][0] == "false"))
                  ) {
                    param1[`prev_${p}`] = this.prevValueMap[`${device_id}_${p}`];
                    param1[`current_${p}`] = this.stateChangedForDevice[p]
                    param1["request_status"] = "failure";
                    snackbarContent.icon = "error";
                    snackbarContent.message = this.$t(`Failed to inverter ${this.stateChangedForDevice.name} - ${this.idParamMap[device_id][p].name}`);
                    this.snackbarList.push(snackbarContent)
                  }
                  
                  promiseList.push(this.insertLog(param1));
                }
              );
              
              Promise.all(promiseList)
            }
          }
        } else if (topic.startsWith("live/")) {
          if (topic.endsWith('inverter')) {
            const mqttData = payload.deviceList[0]

            let isInvPresent = this.inverterList.some(el => el.device_id == mqttData.device_id)
            if (isInvPresent) {
              this.valueMap[`${mqttData.device_id}_active_power`] = mqttData.ac_power != null ? mqttData.ac_power : null
              this.valueMap[`${mqttData.device_id}_reactive_power`] = mqttData.reactive_power != null ? mqttData.reactive_power : null
              this.valueMap[`${mqttData.device_id}_apparent_power`] = mqttData.apparent_power != null ? mqttData.apparent_power : null
              if (this.valueChangedForDevice[mqttData.device_id]) {
                delete this.valueChangedForDevice[mqttData.device_id]
              }
            }
          }
        } else if (topic.startsWith("control/state_change/")) {
          const { device_id, device_type, etilog_id, state } = payload;
          if (device_type == 'inverter') {
            this.$set(this.inverterStatus, device_id, state);
          }
        }
      });
    },
    unsubscribeToTopics() {
      this.$mqtt.unsubscribe(`control_feedback/${this.getSelectedPlantId}/#`);
      this.$mqtt.unsubscribe(`epicConnection/${this.getSelectedPlantId}`);
      this.$mqtt.unsubscribe(`live/${this.getSelectedPlantId}/inverter`);
      this.$mqtt.unsubscribe(
        `control/state_change/${this.getSelectedPlantId}/inverter`
      );
    },
    clickInverter(deviceDetail, param) {
      this.stateChangedForDevice = {
        name: deviceDetail.name,
        etilog_id: deviceDetail.etilog_id,
        device_id: deviceDetail.device_id,
        device_type: deviceDetail.device_type,
        category: deviceDetail.category,
        interface: deviceDetail.device_interface,
        param
      };

      if (param == "state") {
        this.stateChangedForDevice["state"] = Number(
          !!!this.inverterStatus[deviceDetail.device_id]
        );
      }

      if (param == "other param") {
        Object.keys(this.valueChangedForDevice[deviceDetail.device_id]).forEach(
          (param) => {
            this.stateChangedForDevice[param] =
              this.valueChangedForDevice[deviceDetail.device_id][param];
          }
        );
      }
      if (this.etilogConnected[deviceDetail.etilog_id]) {
        this.dialogPassword = true;
      } else {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Sorry Connection Lost with Device"),
        };

        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);
      }
    },
    async checkPassword(email, password) {
      this.emailId = email;
      this.password = password;

      if (password.length <= 1) {
        let payload = {
          icon: "error",
          header: "",
          message: this.$t("Username or password entered is incorrect"),
        };
        this.SET_SNACKBAR_CONTENT(payload);
        this.SET_SHOW_SNACKBAR(true);

        return;
      }

      try {
        await this.validateUserAction({
          email,
          password,
        })
        if (this.etilogConnected[this.stateChangedForDevice.etilog_id]) {
          this.confirmationDialog = true;
        } else {
          let payload = {
            icon: "error",
            header: "",
            message: this.$t("Sorry Connection Lost with Device"),
          };
          this.SET_SNACKBAR_CONTENT(payload);
          this.SET_SHOW_SNACKBAR(true);
        }
      } catch (err) {
        console.log(err);
      }
    },
    changeState() {
      if (!this.multiple) {
        const {
          name,
          etilog_id,
          device_id,
          device_type,
          state,
          active_power,
          reactive_power,
          apparent_power,
        } = this.stateChangedForDevice;
        let blockPath = device_id.split("-").join("/");
        this.topicValue = `control/${this.getSelectedPlantId}/${etilog_id}/${device_type}/${blockPath}`;

        const msg = {
          plant_id: this.getSelectedPlantId,
          device_id: device_id,
          device_name: name,
          device_type: device_type,
        };

        if (state != undefined) {
          msg["status"] = Number(state);
        }

        if (active_power != undefined) {
          msg["active_power"] = Number(active_power);
        }

        if (reactive_power != undefined) {
          msg["reactive_power"] = Number(reactive_power);
        }

        if (apparent_power != undefined) {
          msg["apparent_power"] = Number(apparent_power);
        }

        console.log('publishing', this.topicValue, 'MESSAGE', JSON.stringify(msg))
        this.$mqtt.publish(this.topicValue, JSON.stringify(msg));
      } else {
        // You can only control multiple states of inverter at a time not the param values
        this.inverterSelectList.forEach((el) => {
          const config = this.idInvDetailMap[el.value][0];

          let blockPath = config.device_id.split("-").join("/");
          this.topicValue = `control/${this.getSelectedPlantId}/${config.etilog_id}/${config.device_type}/${blockPath}`;
          const msg = {
            plant_id: this.getSelectedPlantId,
            device_id: config.device_id,
            device_name: config.name,
            device_type: config.device_type,
            status: this.dialogInputOnOffValue.value,
          };

          console.log('publishing 2', this.topicValue, 'MESSAGE', JSON.stringify(msg))
          this.$mqtt.publish(this.topicValue, JSON.stringify(msg));
        });
      }
    },
    async getInverterList(invData) {
      const response = await Controlling.getV2InverterList(
        this.getSelectedPlantId
      );
      this.inverterList = response.data.message;

      const idParamMap = {};
      this.inverterList.forEach((el) => {
        this.$set(this.etilogConnected, el.etilog_id, el.apic_connected);
        this.$set(this.inverterStatus, el.device_id, el.state);
        idParamMap[el.device_id] = {};
        Object.keys(el.params).forEach((p) => {
          idParamMap[el.device_id][p] = {
            name: el.params[p].label,
            max: el.params[p].range[`max_${p}`],
            min: el.params[p].range[`min_${p}`],
          };

          if (p == 'active_power') {
            this.$set(
              this.valueMap,
              `${el.device_id}_${p}`,
              invData[el.device_id] && invData[el.device_id]['ac_power'] != null
                ? invData[el.device_id]['ac_power']
                : null
            );
          } else {
            this.$set(
              this.valueMap,
              `${el.device_id}_${p}`,
              invData[el.device_id] && invData[el.device_id][p] != null
                ? invData[el.device_id][p]
                : null
            );
          }
        });

        this.inverterSelectMap[el.device_id] = false;
        this.valueChangedForDevice = {}
      });
      this.idParamMap = idParamMap;
    },
    async insertLog(param) {
      await Controlling.insertEventLog(param);
    },
    async getEventLog() {
      const timeFrom = moment(`${this.date} ${this.timeFrom}`).format("X");
      const timeTo = moment(`${this.date} ${this.timeTo}`).format("X");
      const response = await Controlling.fetchEventLog(
        this.getSelectedPlantId,
        'inverter',
        timeFrom,
        timeTo
      );
      this.eventLogData = response.data.message.map((el) => {
        let prevVal = '', currentVal = ''
        if (el.prev_status != null || el.current_status != null) {
          prevVal = `State: ${el.prev_status == 0 ? 'OFF' : 'ON'}`
          currentVal = `State: ${el.current_status == 0 ? 'OFF' : 'ON'}`
        } else {
          if (el.prev_active_power != null || el.current_active_power != null) {
            prevVal = `${this.idInvDetailMap[el.device_id][0].params['active_power'].label}: ${el.prev_active_power}`
            currentVal = `${this.idInvDetailMap[el.device_id][0].params['active_power'].label}: ${el.current_active_power}`
          } else if (el.prev_reactive_power != null || el.current_reactive_power != null) {
            prevVal = `${this.idInvDetailMap[el.device_id][0].params['reactive_power'].label}: ${el.prev_reactive_power}`
            currentVal = `${this.idInvDetailMap[el.device_id][0].params['reactive_power'].label}: ${el.current_reactive_power}`
          } else if (el.prev_aparent_power != null || el.current_aparent_power != null) {
            prevVal = `${this.idInvDetailMap[el.device_id][0].params['aparent_power'].label}: ${el.prev_aparent_power}`
            currentVal = `${this.idInvDetailMap[el.device_id][0].params['aparent_power'].label}: ${el.current_aparent_power}`
          }
        }
        return {
          timestamp: moment.unix(el.timestamp).format("YYYY-MM-DD HH:mm"),
          device_name: el.device_name,
          category: el.category,
          prev_value: prevVal,
          current_value: currentVal,
          request_status:
            el.request_status.charAt(0).toUpperCase() +
            el.request_status.slice(1),
          updated_by: el.updated_by,
        };
      });
    },
    toggleHandler(e, item) {
      const id = `${item.device_id}-${item.name}`;
      e.preventDefault();
      const tag = document.getElementById(id);

      if (tag.classList.contains("disabled")) {
        return;
      }
      this.clickInverter(item, "state");
    },
    changeSort(column) {
      if (column != "") {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      }
    },
    onChangeHandler(val) {
      this.inverterSelectList = val;

      Object.keys(this.inverterSelectMap).forEach((id) => {
        this.inverterSelectMap[id] = val.some((el) => el.value == id);
      });
    },
    soloInverterSelectHandler(val, id) {
      this.inverterSelectMap[id] = val;

      if (val) {
        if (!this.inverterSelectList.some((d) => d.value == id)) {
          this.inverterSelectList.push({
            text: this.idInvDetailMap[id][0].name,
            value: id,
          });
        }
      } else {
        this.inverterSelectList = this.inverterSelectList.filter(
          (d) => d.value != id
        );
      }

      if (this.inverterSelectList.length > 0) {
        this.multiple = true;
      } else {
        this.multiple = false;
      }

      if (this.inverterSelectList.length == 0) {
        this.isSelectAll = false
      }
    },
    selectAllInvHandler(val) {
      this.isSelectAll = val;
      this.multiple = val;
    },
  },

  watch: {
    async getSelectedPlantId() {
      this.unsubscribeToTopics();
      this.listenToMqttTopics();

      const response = await Controlling.getInverterData(this.getSelectedPlantId);
      await this.getInverterList(response.data.message);
    },
    isSelectAll(val) {
      if (val) {
        const selectedInv = [];
        Object.keys(this.inverterSelectMap).forEach((device_id) => {
          this.$set(this.inverterSelectMap, device_id, true);
          selectedInv.push({
            text: this.idInvDetailMap[device_id][0].name,
            value: device_id,
          });
        });
        this.inverterSelectList = selectedInv;
      } else {
        Object.keys(this.inverterSelectMap).forEach((device_id) => {
          this.$set(this.inverterSelectMap, device_id, false);
        });
        this.inverterSelectList = [];
      }
    },
    isMultiDialogAndSnack() {
      if (this.isMultipleSnackbar && !this.isSnackBar) {
        if (this.snackbarList.length > 0) {
          const obj = this.snackbarList.shift()
          this.SET_SNACKBAR_CONTENT(obj);
          this.SET_SHOW_SNACKBAR(true);
        } else {
          this.isMultipleSnackbar = false;
        }
      }
    }
  },
};
</script>

<style scoped>
.custom-divider {
  background-color: #334079;
}

.toggle {
  position: relative;
  display: block;
  margin: 0 auto;
  width: 90px;
  height: 40px;
  outline: 0;
  text-decoration: none;
  border-radius: 5px;
  border: 2px solid #546e7a;
  background-color: var(--v-bg-base);
  transition: all 500ms;
}

.disabled {
  opacity: 0.3;
}

.disabled:hover {
  cursor: not-allowed;
}

.theme--dark .toggle:active {
  background-color: #1e272e;
}

.theme--light .toggle:active {
  background-color: #455a64;
}

.toggle:hover:not(.toggle--moving):after {
  background-color: #455a64;
}

.toggle:after {
  display: block;
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  line-height: 25px;
  text-align: center;
  text-transform: uppercase;
  font-size: 16px;
  color: white;
  background-color: #000427;
  border: 2px solid;
  transition: all 500ms;
}

.theme--light .toggle:after {
  background-color: #fff;
}

.toggle--on:after {
  content: "On";
  border-radius: 5px 3px 3px 5px;
  color: #3cb371;
}

.toggle--off:after {
  content: "Off";
  border-radius: 3px 5px 5px 3px;
  transform: translate(100%, 0);
  color: #ff5252;
}

.toggle--moving {
  background-color: #1e272e;
}

.theme--light .toggle--moving {
  background-color: #455a64;
}

.toggle--moving:after {
  color: transparent;
  border-color: #4f6c7a;
  background-color: #2b3d44;
  transition: color 0s, transform 500ms, border-radius 500ms,
    background-color 500ms;
}

.custom-data-table {
  height: 71vh;
  overflow-y: auto;
  border-radius: 8px !important;
  border: 1px solid #334079;
}

/* To add vertical lines between columns */
.custom-data-table thead th:not(:last-child),
.custom-data-table tbody td:not(:last-child) {
  border-right: 1px solid #334079;
}

.custom-data-table thead th {
  height: 48px;
  font-size: 14px;
  font-weight: 700 !important;
}

.custom-data-table th {
  z-index: 1;
  position: sticky;
  top: 0;
}

.theme--dark .custom-data-table thead th {
  color: #fff !important;
}

.theme--light .custom-data-table thead th {
  color: #000 !important;
}

.main-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
}
</style>


<style>
.custom-checkbox > .v-input__control > .v-input__slot {
  margin-bottom: 0px !important;
}

.parameter-text > .v-input__control > .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-input--is-focused .v-input__slot {
  border: 2px solid #2196f3 !important;
}

.theme--dark
  .v-input--is-focused
  .v-input__slot
  > .v-text-field__slot
  > .v-label--active {
  color: #fff !important;
}

.theme--light
  .v-input--is-focused
  .v-input__slot
  > .v-text-field__slot
  > .v-label--active {
  color: #000 !important;
}

.theme--dark .v-input--is-disabled > .v-input__control > .v-input__slot {
  border-color: #555 !important;
}

.theme--light .v-input--is-disabled > .v-input__control > .v-input__slot {
  border-color: #afaeae !important;
}
</style>